export default __webpack_public_path__ + "assets/img/background-gnss.37a3090.png";